<template>
  <div class="grid-string">
    <template v-for="group in order">
      <div
        v-if="group.name"
        :key="group.name"
        :class="'cell-header-span-row-' + group.fields.length"
        class="cell cell-header"
      >
        <div :class="group.color" class="unite">
          <div>{{ group.name }}, {{ currency }}</div>
        </div>
      </div>
      <HeaderCell
        v-for="field in group.fields"
        :key="field.slug"
        :field="field"
        :name="field.name"
        :currency="currency"
        :editable="editable"
        v-bind="field.header"
        :class="[{ 'fix-right': field.header.fixRight === 'list' }, field.header.class]"
        @change="$emit('changeName', { name: $event, field: field.slug })"
        @contextmenu.native="openContextMenu($event, field)"
        @make-wider="$emit('make-wider', field)"
        @make-narrower="$emit('make-narrower', field)"
      />
    </template>
  </div>
</template>

<script>
  import HeaderCell from '@/components/project/list/HeaderCell';
  import HeaderContext from '@/components/project/list/contexts/Header';
  import { mapActions } from 'vuex';

  export default {
    name: 'ListHeader',
    components: { HeaderCell },
    props: {
      order: {
        type: Array,
        default: () => [],
      },

      editable: {
        type: Boolean,
        default: false,
      },

      isLabourDivided: {
        type: Boolean,
        default: false,
      },
      currency: {
        type: String,
        default: '',
      },
    },

    methods: {
      ...mapActions({
        openContext: 'context/open',
      }),

      openContextMenu(e, field) {
        e.preventDefault();

        const allowAddColumn = field.header.allowAddColumn && this.editable;
        const allowDeleteColumn = field.header.allowDeleteColumn && this.editable;
        const hourlyRateOption = field.header.hourlyRateOption && this.editable;
        const amount =
          (allowAddColumn ? 1 : 0) + (allowDeleteColumn ? 1 : 0) + (hourlyRateOption ? 1 : 0) || 0;
        if (!amount) return;

        this.openContext({
          pageX: e.pageX,
          pageY: e.pageY,
          type: e.type,

          options: amount,
          optionsHeight: 28,
          component: HeaderContext,

          allowAddColumn,
          allowDeleteColumn,
          hourlyRateOption: false,
          isLabourDivided: this.isLabourDivided,

          add: () => this.$emit('addColumn'),
          delete: () => this.$emit('deleteColumn', field.slug),
          showHourlyRate: () => this.$emit('showHourlyRate'),
          hideHourlyRate: () => this.$emit('hideHourlyRate'),
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .unite {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    -webkit-transition: opacity 200ms ease;
    transition: opacity 200ms ease;
    color: #54637a;
    cursor: pointer;
  }
</style>
